export default "__VITE_ASSET__BWgcBEu7__"